export const MIN_DATE: Date = new Date(1990, 0, 1);
